import { definePreset } from '@primeuix/themes'
import Aura from '@primeuix/themes/aura'

const Krewebacchus = definePreset(Aura, {
  semantic: {
    primary: {
      // Neon green shades - complete palette
      50: '#F0FFE9', // Very light mint hint
      100: '#E0FFD4', // Very light mint green
      200: '#C0FFA9', // Light mint green
      300: '#91FF6E', // Medium light green
      400: '#65FF3C', // Lighter neon green
      500: '#23B00D', // Base neon green (main color) - DARKER for light mode
      600: '#32E912', // Slightly darker
      700: '#2BD310', // Darker
      800: '#23B00D', // Dark green
      900: '#1A8A0A', // Very dark green
      950: '#146707', // Almost black green
    },
    colorScheme: {
      dark: {
        primary: {
          500: '#39FF14', // Keep the bright neon green in dark mode
        },
      },
    },

    surface: {
      // Add blue-tinted surfaces for tech feel - complete palette
      50: '#F8FAFF', // Very light blue-tinted white
      100: '#F0F5FF', // Very light blue
      200: '#E5EEFF', // Light blue
      300: '#D0E0FF', // Medium light blue
      400: '#A0C0FF', // Medium blue
      500: '#6090E0', // Medium dark blue
      600: '#4060B0', // Dark blue
      700: '#304080', // Very dark blue
      800: '#202850', // Very very dark blue
      900: '#121B29', // Almost black blue (deep space)
      950: '#0A1018', // Darkest blue-black
    },
    // Add danger color with a cyberpunk red feel
    danger: {
      500: '#FF3E5E', // Neon red
      600: '#E03655', // Darker neon red
    },
    // Add warning with amber/orange for alerts
    warning: {
      500: '#FFB114', // Amber alert color
      600: '#E09A12', // Darker amber
    },
    // Add info with a cyan/blue for tech feel
    info: {
      500: '#14CFFF', // Cyber blue
      600: '#12B8E9', // Darker cyber blue
    },
    // Add success with green similar to primary but distinct
    success: {
      500: '#14FF83', // Neon mint
      600: '#12E975', // Darker neon mint
    },
  },
  // Add custom properties for sci-fi elements
  extend: {
    variables: {
      // Circuit pattern for backgrounds
      '--circuit-pattern': 'url("data:image/svg+xml,%3Csvg width=\'100\' height=\'100\' viewBox=\'0 0 100 100\' xmlns=\'http://www.w3.org/2000/svg\'%3E%3Cpath d=\'M10 10h5v5h-5zM20 10h5v5h-5zM30 10h5v5h-5zM10 20h5v5h-5zM30 20h5v5h-5zM10 30h5v5h-5zM20 30h5v5h-5zM30 30h5v5h-5z\' fill=\'%2339FF14\' fill-opacity=\'0.1\' fill-rule=\'evenodd\'/%3E%3C/svg%3E")',

      // Glow effects
      '--glow-effect': '0 0 10px var(--primary-color)',
      '--glow-effect-strong': '0 0 15px var(--primary-color), 0 0 30px var(--primary-color-400)',
      '--glow-text': '0 0 5px currentColor',

      // Tech styling
      '--tech-border-radius': '0 8px 0 8px',
      '--panel-border': '1px solid rgba(57, 255, 20, 0.3)',
      '--terminal-font': '"courier", monospace',

      // Animations
      '--scan-line-speed': '6s',
      '--holo-pulse-speed': '3s',
    },
  },
})

export default {
  preset: Krewebacchus,
  options: {
    prefix: 'p',
    darkModeSelector: '.dark',
    cssLayer: false,
  },
}
